import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/Shared";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ShieldCheck, Garage } from "@phosphor-icons/react";
import GateVehicleApproval from "@/pages/GateVehicleApproval";
import VehicleManagement from "@/pages/VehicleManagement";

// Merged "Vehicles" page — one nav entry replacing the separate Community "Vehicle
// Management" and Gate "Vehicle Approval" screens. They operate on two different
// collections (parking_vehicles vs vehicles) and are auto-synced server-side; this
// view simply groups them under one roof per owner's request so there's no confusion
// about which tab to use.
export default function Vehicles() {
    const { user } = useAuth();
    const canSeeGateAccess = user?.role === "admin";
    const [tab, setTab] = useState(canSeeGateAccess ? "gate" : "parking");

    return (
        <div className="animate-fade-up" data-testid="vehicles-page">
            <PageHeader overline="Community & Gate" title="Vehicles" description="Gate entry approval and the parking/ownership registry, in one place." />

            <Tabs value={tab} onValueChange={setTab} className="mb-6">
                <TabsList data-testid="vehicles-tabs-list">
                    {canSeeGateAccess && (
                        <TabsTrigger value="gate" data-testid="vehicles-tab-gate">
                            <ShieldCheck size={16} className="mr-1.5" /> Gate Access
                        </TabsTrigger>
                    )}
                    <TabsTrigger value="parking" data-testid="vehicles-tab-parking">
                        <Garage size={16} className="mr-1.5" /> Parking & Ownership
                    </TabsTrigger>
                </TabsList>
            </Tabs>

            {tab === "gate" && canSeeGateAccess && <GateVehicleApproval />}
            {tab === "parking" && <VehicleManagement />}
        </div>
    );
}
